import { registerEnumSet } from '@if/mui'
import {
  Ban,
  CalendarX2,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CircleX,
  Clock,
  Eye,
  FileText,
  Hash,
  LoaderCircle,
  PencilLine,
  PenLine,
  TriangleAlert,
} from 'lucide-react'
import { ECreditApplicationStatusMessage } from './viewCreditApp-selectors'

// Registers each status message (color + icon + label) so EnumChip/EnumBanner render it consistently. Load-once at bootstrap.
registerEnumSet(ECreditApplicationStatusMessage, {
  [ECreditApplicationStatusMessage.Completed]: {
    color: 'success',
    icon: CircleCheck,
    labelKey: 'creditApplicationStatus.completed',
  },
  [ECreditApplicationStatusMessage.CreditReportNotFound]: {
    color: 'error',
    icon: CircleX,
    labelKey: 'creditApplicationStatus.creditReportNotFound',
  },
  [ECreditApplicationStatusMessage.Declined]: {
    color: 'error',
    icon: CircleX,
    labelKey: 'creditApplicationStatus.declined',
  },
  [ECreditApplicationStatusMessage.Cancelled]: {
    color: 'error',
    icon: Ban,
    labelKey: 'creditApplicationStatus.cancelled',
  },
  [ECreditApplicationStatusMessage.Expired]: {
    color: 'error',
    icon: CalendarX2,
    labelKey: 'creditApplicationStatus.expired',
  },
  [ECreditApplicationStatusMessage.Error]: {
    color: 'error',
    icon: CircleAlert,
    labelKey: 'creditApplicationStatus.applicationError',
  },
  [ECreditApplicationStatusMessage.DocumentsRequired]: {
    color: 'warning',
    icon: FileText,
    labelKey: 'creditApplicationStatus.documentsRequired',
  },
  [ECreditApplicationStatusMessage.ActionRequired]: {
    color: 'warning',
    icon: TriangleAlert,
    labelKey: 'creditApplicationStatus.actionRequired',
  },
  [ECreditApplicationStatusMessage.AwaitingSignature]: {
    color: 'warning',
    icon: PenLine,
    labelKey: 'creditApplicationStatus.awaitingSignature',
  },
  [ECreditApplicationStatusMessage.SinRequired]: {
    color: 'warning',
    icon: Hash,
    labelKey: 'creditApplicationStatus.sinRequired',
  },
  [ECreditApplicationStatusMessage.ManualRevision]: {
    color: 'info',
    icon: Eye,
    labelKey: 'creditApplicationStatus.manualRevision',
  },
  [ECreditApplicationStatusMessage.AwaitingApproval]: {
    color: 'info',
    icon: Clock,
    labelKey: 'creditApplicationStatus.awaitingApproval',
  },
  [ECreditApplicationStatusMessage.Waiting]: {
    color: 'info',
    icon: Clock,
    labelKey: 'creditApplicationStatus.waiting',
  },
  [ECreditApplicationStatusMessage.Progress]: {
    color: 'info',
    icon: LoaderCircle,
    labelKey: 'creditApplicationStatus.inProgress',
  },
  [ECreditApplicationStatusMessage.Processing]: {
    color: 'info',
    icon: LoaderCircle,
    labelKey: 'creditApplicationStatus.processing',
  },
  [ECreditApplicationStatusMessage.Draft]: {
    color: 'info',
    icon: PencilLine,
    labelKey: 'creditApplicationStatus.draft',
  },
  [ECreditApplicationStatusMessage.Active]: {
    color: 'info',
    icon: CircleDot,
    labelKey: 'creditApplicationStatus.active',
  },
})
